import React from 'react';
import { useNavigate  } from 'react-router-dom';

import S from './Button.module.css';

import topArrow from '../../assets/images/common/topArrow.png';
import backArrow from '../../assets/images/common/backArrow.png';

const TopBackBtn = () => {
  
  const navigate = useNavigate(); // useNavigate 훅 사용

  // 화면 상단으로 이동하는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 부드럽게 스크롤
    });
  };

  // 이전 페이지로 이동하는 함수
  const goBack = () => {
    navigate(-1); // useNavigate로 이전 페이지로 이동
  };

  return (
    <div className={S.tbBtnWrap}>
      <div onClick={scrollToTop} className={S.tbBtnDiv}>
        <img src={topArrow} alt='top' />
      </div>
      <div onClick={goBack} className={S.tbBtnDiv}>
        <img src={backArrow} alt='back' />
      </div>
    </div>
  );
}

export default TopBackBtn;
